import { render, staticRenderFns } from "./HeaderAnchor.vue?vue&type=template&id=1c546701"
import script from "./HeaderAnchor.vue?vue&type=script&lang=js"
export * from "./HeaderAnchor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports